import {AccordionV2 as AccordionPepsico} from 'pepsico-ds'
import React from 'react'

/**
 * Accordion component that wraps content inside an AccordionPepsico component.
 *
 * @param {Object} props - The properties object.
 * @param {string} [props.presentation='box-shadow'] - The presentation style of the accordion.
 * @param {string} [props.content=''] - The content to be displayed inside the accordion.
 * @param {boolean} [props.isDark=false] - Flag to indicate if the dark theme should be applied.
 * @param {Function} props.onUpdate - Callback function to handle updates.
 * @param {boolean} [props.separator=false] - Flag to indicate if a separator should be displayed.
 * @param {Function} props.onClickAdd - Callback function to handle the add button click.
 * @param {string} [props.accordionTitle=''] - The title of the accordion.
 * @param {number} props.selectedItemIndex - The index of the selected item.
 *
 * @returns {JSX.Element} The rendered Accordion component.
 */
function Accordion({
  presentation = 'box-shadow',
  content = '',
  isDark = false,
  onUpdate,
  separator = false,
  onClickAdd,
  accordionTitle = '',
  selectedItemIndex,
}) {
  return (
    <AccordionPepsico
      presentation={presentation}
      isDark={isDark}
      onUpdate={onUpdate}
      separator={separator}
      onClickAdd={onClickAdd}
      accordionTitle={accordionTitle}
      selectedItemIndex={selectedItemIndex}
    >
      {content}
    </AccordionPepsico>
  )
}

export default Accordion
